<div class="container-fluid mat-elevation-z8">
  <div class="loading-shade"
       *ngIf="isLoading || hasError">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <div class="has-error" *ngIf="hasError">
      There was an error loading the users.
    </div>
  </div>

  <div class="w-100 p-3">
    <mat-form-field class="w-100">
      <mat-label>Search Query</mat-label>
      <input matInput placeholder="User ID, email, name, phone, Instagram or TikTok" (change)="queryChanged($event)">
      <mat-hint>A user ID or an email address is looked up exactly — a deleted account is still found.</mat-hint>
    </mat-form-field>
  </div>
  <div class="w-100 px-3">
    <sa-timezone-toggle></sa-timezone-toggle>
  </div>
  <div class="w-100 px-3">
    <sa-filters-container [filters]="filters | async" (onFiltersUpdated)="onFiltersUpdated($event)"></sa-filters-container>
  </div>
  <section class="w-100 p-3 d-flex justify-content-end align-items-center flex-wrap">
    <!-- Video and photo profiles behave differently in the deck, so reviewing
         one kind at a time is a real need rather than a cosmetic filter. -->
    <mat-button-toggle-group class="media-filter me-3" value="" (change)="mediaFilterChanged($event.value)"
                             aria-label="Media type">
      <mat-button-toggle value="">All media</mat-button-toggle>
      <mat-button-toggle value="video" title="Profiles with at least one playable video">Video</mat-button-toggle>
      <mat-button-toggle value="photo" title="Profiles with no playable video">Photo only</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-checkbox [checked]="ratedOnly | async" (change)="ratedOnly.next($event.checked)" class="me-2"
                  title="Only profiles with at least 10 likes and dislikes combined — the ones the like/dislike colour applies to">Rated users only (10+ votes)</mat-checkbox>
    <mat-checkbox [checked]="incompleteOnboarding | async" (change)="incompleteOnboarding.next($event.checked)" class="me-2">Incomplete onboarding</mat-checkbox>
    <mat-checkbox [checked]="hideBannedCountries | async" (change)="hideBannedCountries.next($event.checked)" class="me-2">Hide users from banned countries</mat-checkbox>
    <mat-checkbox [checked]="hideMockUsers | async" (change)="hideMockUsersChanged($event.checked)" class="me-2">Hide mock users</mat-checkbox>
    <mat-checkbox [checked]="showDeletedUsers | async" (change)="showDeletedUsers.next($event.checked)">Show deleted users</mat-checkbox>
  </section>
  <div class="w-100">
    <sa-users-table
      [displayedColumns]="getDisplayedColumns()"
      [data]="data"
      [initialSort]="getSort()"
      [highlightIncomplete]="incompleteOnboarding | async"
      (userClicked)="userClicked($event)"
      (userBanClicked)="userBanClicked($event)"
      (userUnBanClicked)="userUnBanClicked($event)"
      (userPutUnderReviewClicked)="userPutUnderReviewClicked($event)"
      (userRemoveFromReviewClicked)="userRemoveFromReviewClicked($event)"
      (userSilentHideClicked)="userSilentHideClicked($event)"
      (userSilentUnhideClicked)="userSilentUnhideClicked($event)"
      (userDeleteClicked)="userDeleteClicked($event)"
      (userBoostClicked)="userBoostClicked($event)"
      (userDeboostClicked)="userDeboostClicked($event)"
      (sortChange)="sortChanged($event)"
    >
    </sa-users-table>
  </div>

  <div class="container-fluid d-flex">
    <mat-paginator class="d-inline-block" [length]="resultsLength" [pageSize]="limit" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true"></mat-paginator>
    <div class="d-flex flex-wrap align-content-center">
      <div class="pe-2">Go to </div>
      <input class="w-auto" matInput placeholder="page" (change)="pageChanged($event)"></div>
  </div>
</div>
